"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchInput = void 0;
var react_1 = __importStar(require("react"));
var Button_1 = require("@nerdwallet/currency/components/Button");
var features_1 = require("@nerdwallet/features");
var seo_analytics_1 = require("@nerdwallet/seo-analytics");
var close_icon_1 = __importDefault(require("./close-icon"));
var magnifying_glass_1 = __importDefault(require("./magnifying-glass"));
var search_input_module_css_1 = __importDefault(require("./search-input.module.css"));
var SearchInput = function (_a) {
    var _b = _a.autoFocus, autoFocus = _b === void 0 ? true : _b, className = _a.className, _c = _a.initialValue, initialValue = _c === void 0 ? "" : _c, _d = _a.placeholder, placeholder = _d === void 0 ? 'Try "Best savings account?"' : _d, _e = _a.searchBaseUri, searchBaseUri = _e === void 0 ? "https://www.nerdwallet.com" : _e;
    var inputRef = (0, react_1.useRef)(null);
    var analytics = (0, seo_analytics_1.useSegmentAnalytics)().analytics;
    var _f = (0, react_1.useState)(initialValue), searchQuery = _f[0], setSearchQuery = _f[1];
    var assignedVariantName = (0, features_1.useExperiment)({
        testName: "cad_1011_new_onsite_search",
        vendor: "absmartly",
    }).assignedVariantName;
    var onClearInput = (0, react_1.useCallback)(function () {
        if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
            setSearchQuery("");
            inputRef.current.focus();
        }
    }, [inputRef, setSearchQuery]);
    var onSearch = (0, react_1.useCallback)(function () {
        var _a;
        if (inputRef === null || inputRef === void 0 ? void 0 : inputRef.current) {
            analytics === null || analytics === void 0 ? void 0 : analytics.track("feature_interacted", {
                entity_name: "onsite_search_search_button",
                section_name: "onsite_search",
                item_copy: "Search",
                interaction_type: "clicked",
            });
            // set URL path based on experiment or if user is already on a search page
            var urlPath = assignedVariantName === "beta" ? "/search/beta" : "/search/results";
            if (((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.pathname) === "/search/beta") {
                urlPath = "/search/beta";
            }
            var url = "".concat(searchBaseUri).concat(urlPath, "?q=").concat(encodeURIComponent(searchQuery));
            window.location.href = url;
        }
    }, [inputRef, analytics, searchQuery, assignedVariantName]);
    var checkEnter = (0, react_1.useCallback)(function (e) {
        if (e.key === "Enter") {
            onSearch();
        }
    }, [onSearch]);
    return (react_1.default.createElement("search", { className: "".concat(search_input_module_css_1.default.searchInputContainer, " ").concat(className) },
        react_1.default.createElement("div", { className: search_input_module_css_1.default.inputWrapper },
            react_1.default.createElement(magnifying_glass_1.default, { className: search_input_module_css_1.default.searchIcon }),
            react_1.default.createElement("input", { autoFocus: autoFocus, className: search_input_module_css_1.default.inputBox, type: "search", name: "searchInput", ref: inputRef, value: searchQuery, placeholder: placeholder, "aria-label": "Search the NerdWallet site", onKeyDown: checkEnter, onChange: function (e) { return setSearchQuery(e.target.value); } }),
            searchQuery.length > 0 && (react_1.default.createElement("span", { className: search_input_module_css_1.default.closeIcon, onClick: onClearInput, onKeyDown: onClearInput, role: "button", tabIndex: 0, "aria-label": "Clear search input" },
                react_1.default.createElement(close_icon_1.default, null)))),
        react_1.default.createElement(Button_1.Button, { primary: true, onClick: onSearch, className: search_input_module_css_1.default.searchButton }, "Search")));
};
exports.SearchInput = SearchInput;
exports.default = exports.SearchInput;
